import React, {Component} from 'react'
import {connect} from 'react-redux'
import BackOfficeNavigatorScreen from '../screens/BackOfficeNavigatorScreen'
import {Route, Switch, Redirect} from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {actions as authActions} from '../redux/modules/Auth'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserDetailContainer from './BackOfficeUserDetailContainer'
import BackOfficeUserTableContainer from './BackOfficeUserTableContainer'
import BackOfficeUserCreateContainer from './BackOfficeUserCreateContainer'
import BackOfficeUserEditContainer from './BackOfficeUserEditContainer'
import BackOfficeMarksTableContainer from './BackOfficeMarksTableContainer'
import BackOfficeVehiclesTableContainer from './BackOfficeVehiclesTableContainer'
import BackOfficeParkingPassTableContainer from './BackOfficeParkingPassTableContainer'
import BackOfficeReceiptsTableContainer from './BackOfficeReceiptsTableContainer'
import BackOfficeReceiptCreateContainer from './BackOfficeReceiptCreateContainer'
import BackOfficeUserWaitingListTableContainer from './BackOfficeUserWaitingListTableContainer'

const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  }
}

class BackOfficeContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      thingsToDo: {
        // waitingUsers: 0,
        waitingMarks: 0,
        waitingParkingPasses: 0
      }
    }
  }

  onLogoutClick () {
    this.props.authActions.logout()
  }

  render () {
    return (
      <Switch>
        <Route path="/backoffice/users/create" component={BackOfficeUserCreateContainer} />
        <Route path="/backoffice/users/waiting-list" component={(props) => <BackOfficeUserWaitingListTableContainer thingsToDo={this.props.thingsToDo} {...props} />} />
        <Route path="/backoffice/users/:id/edit" component={BackOfficeUserEditContainer} />
        <Route path="/backoffice/users/:id" component={BackOfficeUserDetailContainer} />
        <Route path="/backoffice/users" component={(props) => <BackOfficeUserTableContainer thingsToDo={this.props.thingsToDo} {...props} />} />

      </Switch>)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserContainer.js